const alphabet =
  "abcdefghijklmnopqrstuvwxyz" + "ABCDEFGHIJKLMNOPQRSTUVWXYZ" + "0123456789";

function random(seed) {
  // Robert Jenkins’ 32 bit integer hash function
  seed = (seed + 0x7ed55d16 + (seed << 12)) & 0xffffffff;
  seed = (seed ^ 0xc761c23c ^ (seed >>> 19)) & 0xffffffff;
  seed = (seed + 0x165667b1 + (seed << 5)) & 0xffffffff;
  seed = ((seed + 0xd3a2646c) ^ (seed << 9)) & 0xffffffff;
  seed = (seed + 0xfd7046c5 + (seed << 3)) & 0xffffffff;
  seed = (seed ^ 0xb55a4f09 ^ (seed >>> 16)) & 0xffffffff;
  return seed & 0xfffffff;
}

function roomToSeed(roomName) {
  let result = 0;
  for (let i = 0; i < roomName.length; i++) {
    result *= alphabet.length;
    result += alphabet.indexOf(roomName[i]);
  }
  return result;
}

export { alphabet, random, roomToSeed };
